import { EnKeysProps } from './en';

export const en: EnKeysProps = {
  'sports.allsports.azheading': 'Sports',
  'generic.sportAZ': 'A-Z',
  'sports.matchDetailPage.clearAll': 'Clear',
  'betslip.betslipmodal.emptybetslipheading':
    'Like a fortune cookie yet to reveal its message.',
  'betslip.betslipmodal.emptybetslipsubheading':
    'Your bet slip is empty. To get started, add your racing and sports selections.',
  'betslip.betslipbetcard.errors.propositionclosed': 'This event is closed.',
  'onboarding.register.createAccount': 'Create an account',
  'onboarding.step1.button': 'Join Now',
  'account.withdraw.addbank': 'Add new Bank Account',
  'header.betslipBtn.desc': 'Slip',
  'onboarding.locationnotallowed.header': 'Out of bounds',
  'onboarding.locationnotallowed.subheader':
    'You seem to be accessing Bet575 from outside of Australia',
  'error.heading': 'Time out.',
  'error.description': `<bold>We’re sorry about that. We’ve got someone on it.</bold>
  In the meantime, you can refresh the page, or try again later.`,
  'maintenance.heading': 'Technical difficulties.',
  'maintenance.error': `<bold>We’re currently performing maintenance on the site.</bold>
  In the meantime, you can refresh the page, or try again later.`,
};
